import { Profile } from "../shared/profile.model";
import { Discussion } from "./discussion.model";

export class DiscussionVote {
  id: string;
  type: string = "";
  discussion: Discussion;
  voter: Profile;
  createdAt: string;
  updatedAt: string;
}
